import styled from 'styled-components';
import ErrorDisplay from 'js/components/common/ErrorDisplay';

export default styled(ErrorDisplay)`
  margin-bottom: 0;
`;
